webpackJsonp([275188716799837],{

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/purposely.0e6efa97.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _work = __webpack_require__(25);
	
	var _work2 = _interopRequireDefault(_work);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var purposely = __webpack_require__(126);
	
	var Purposely = function Purposely() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Purposely | Cory Schadt',
	      bodyAttributes: {
	        class: 'inner'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'page fade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Purposely'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Purposely is a volunteer platform that helps communities and organizations connect.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Primary Role:  HTML, CSS, Responsive Design, React Component Creation.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'btn in-progress' },
	                'In Progress'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-feature' },
	        _react2.default.createElement(_work2.default, { noLink: true, raise: true, laptop: true, screen: purposely, color: '#37E0EC' })
	      )
	    )
	  );
	};
	exports.default = Purposely;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-purposely-js-8d8b222bd79b7a15e532.js